import React, { useState, useEffect } from 'react';
import { Popup, TextBox, Button } from 'devextreme-react';


const GroupSettingsPopup = ({group, visible, onClose,handleGroupUpdate }) => {
  const [label, setLabel] = useState('');


  useEffect(() => {
    if (group) {
      setLabel(group.label);
    }
  }, [group]);

  const handleSave = () => {
    handleGroupUpdate({
      ...group,
      label,
    });
    onClose();
  };

  return (
    <Popup
      visible={visible}
      onHiding={onClose}
      dragEnabled={true}
      closeOnOutsideClick={true}
      showCloseButton={true}
      title="Edit Field"
      width={400}
      height={400}
    >
      <div>
        <div className="mb-2">
          <TextBox
            value={label}
            onValueChanged={(e) => setLabel(e.value)}
            placeholder="Label"
          />
        </div>
        <div>
          <Button onClick={handleSave} icon='save' text='Save' />
        </div>
      </div>
    </Popup>
  );
};

export default GroupSettingsPopup;
